<template>
  <div>
    <div class="box">
      <div class="show_1 button-pc">
        <div class="tel">
          <img alt=""
               src="../assets/img/电话咨询.png" />
          <p>电话咨询</p>
        </div>
        <div class="hidden_1">
          <div class="display">
            <span>服务热线</span>
            <span>18082785656</span>
            <div class="triangle"></div>
          </div>
        </div>
      </div>
      <div class="show_2 button-pc">
        <div class="miniProgram">
          <img alt=""
               src="../assets/img/小程序.png" />
          <p>小程序</p>
        </div>
        <div class="hidden_2">
          <div class="display">
            <img alt=""
                 src="../assets/img/小程序.jpg" />
            <p>扫描二维码</p>
            <p class="p2">进入酒师兄小程序商城</p>
            <div class="triangle"></div>
          </div>
        </div>
      </div>
      <div class="show_3 button-pc">
        <div class="officialAccounts">
          <img alt=""
               src="../assets/img/公众号.png" />
          <p>公众号</p>
        </div>
        <div class="hidden_3">
          <div class="display">
            <img alt=""
                 src="../assets/img/公众号.jpg" />
            <p>扫描关注二维码</p>
            <p class="p2">领取更多优惠信息</p>
            <div class="triangle"></div>
          </div>
        </div>
      </div>
      <GoTop>
        <div class="go-top">
          <img alt=""
               src="../assets/img/next.png" />
        </div>
      </GoTop>
    </div>
    <GoTop>
      <div class="go-top-mobile">
        <img alt=""
             src="../assets/img/next.png" />
      </div>
    </GoTop>
    <div class="gif"
         style="cursor: pointer"
         @click="show = true">
      <img alt=""
           src="https://jsx-new.oss-cn-chengdu.aliyuncs.com/website/%E6%88%91%E8%A6%81%E5%8A%A0%E7%9B%9F.gif" />
    </div>
    <div class="backdrop"
         v-if="show"></div>
    <PopupWindow :is-show="show"
                 @close="show = false"></PopupWindow>
  </div>
</template>

<script>
export default {
  name: "RightNav",
  data () {
    return {
      show: false,
      flag: false,
    };
  },
};
</script>

<style scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 9999;
}
.box {
  width: 80px;
  height: 360px;
  position: fixed;
  right: 20px;
  top: 30%;
  background-color: #fff;
  z-index: 999;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid #f2f2f2;
  padding: 8px 10px 0 12px;
}

.box .tel {
  border-bottom: 1px solid #e3e3e3;
}

.hidden_1 {
  opacity: 0;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: absolute;
  left: 200px;
  top: 0;
  width: 112px;
  color: #444;
  font-size: 14px;
  padding: 5px 10px;
  color: #ec473e;
  text-align: center;
  transition: all 0.3s;
}

.triangle {
  border: solid #ccc;
  border-width: 1px 1px 0 0;
  background: #fff;
  width: 10px;
  height: 10px;
  right: 0;
  margin-right: -6px;
  margin-top: -30px;
  position: absolute;
  transform: rotate(45deg);
}

.show_1:hover .display {
  display: block;
}

.show_1:hover .hidden_1 {
  left: -130px;
  top: 25px;
  opacity: 1;
}

.hidden_2 {
  opacity: 0;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: absolute;
  left: 100px;
  top: 72px;
  width: 198px;
  font-size: 14px;
  padding: 5px 10px;
  text-align: center;
  transition: all 0.3s;
}

.hidden_2 .triangle {
  top: 100px;
}

.hidden_2 img {
  height: 90px !important;
  width: 90px !important;
}

.hidden_2 p {
  font-size: 15px !important;
  color: #333 !important;
  font-weight: bold !important;
  margin: 0px !important;
}

.hidden_2 .p2 {
  margin: 0 0 10px !important;
}

.show_2:hover .display {
  display: block;
}

.show_2:hover .hidden_2 {
  left: -220px;
  opacity: 1;
}

.hidden_3 {
  opacity: 0;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: absolute;
  left: 100px;
  top: 200px;
  width: 198px;
  font-size: 14px;
  padding: 5px 10px;
  text-align: center;
  transition: all 0.3s;
}

.hidden_3 .triangle {
  margin-top: -120px;
}

.hidden_3 img {
  height: 90px !important;
  width: 90px !important;
}

.hidden_3 p {
  font-size: 15px !important;
  color: #333 !important;
  font-weight: bold !important;
  margin: 0px !important;
}

.hidden_3 .p2 {
  margin: 0 0 10px !important;
}

.display {
  display: none;
}

.show_3:hover .display {
  display: block;
}

.show_3:hover .hidden_3 {
  left: -220px !important;
  opacity: 1;
}

.box .miniProgram {
  border-bottom: 1px solid #e3e3e3;
}

.box .officialAccounts {
  border-bottom: 1px solid #e3e3e3;
}

.box img {
  width: 30px;
  height: 30px;
  margin: 17px auto 0;
}

.box p {
  text-align: center;
  margin: 13px 0 15px;
  color: #7c7e81;
  font-size: 14px;
  font-weight: 400;
}

.gif {
  width: 80px;
  height: 80px;
  position: fixed;
  right: 20px;
  top: 80%;
  z-index: 999;
  cursor: pointer;
  border-radius: 8px;
}
.gif img {
  width: 80px;
  height: 80px;
}
.go-top img {
  width: 27.5px;
  height: 25.5px;
}
/* pc媒体查询 */
@media screen and (min-width: 468px) {
  .go-top-mobile {
    display: none !important;
  }
}
/* 手机媒体查询 */
@media screen and (max-width: 768px) {
  .box {
    display: none;
  }
  .go-top-mobile {
    display: block !important;
    width: 50px !important;
    height: 50px !important;
    position: fixed !important;
    right: 34px !important;
    top: 72% !important;
    z-index: 999;
    cursor: pointer;
    padding: 15px 12px !important;
    background-color: #fff;
    border-radius: 8px;
  }
  .go-top-mobile img {
    width: 27.5px;
    height: 25.5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RightNav.vue